import { getConfiguredElements } from "src/dynamic-view-renderer/Widgets/RelatedCases/relatedCases.mappings.tsx";
import { RelatedWidgetConfiguration } from "src/dynamic-view-renderer/Widgets/RelatedCases/relatedCases.typings.ts";
import { Element } from "src/types/element";

export type IdentifiersValues = {
  identifierCode: string;
  value: string;
};

export const getAllIdentifiers = (
  configuration: RelatedWidgetConfiguration,
  elements?: Element[]
): IdentifiersValues[] => {
  const identifiers =
    getConfiguredElements(configuration, elements).flatMap(
      (elem) =>
        elem.identifiers?.map((identifier) => ({
          identifierCode: "" /* identifier.identifierType.code */, // ignored by backend
          value: identifier.value,
        })) ?? []
    ) ?? [];

  return Array.from(new Map(identifiers.map((item) => [item.value, item])).values());
};
